import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private readonly API_KEY = 'ira_kqnQEAE7sxRUCKWLlp7hl8G1YPG0GU0yBp6j';
  private readonly API_URL = `https://api.ipregistry.co/?key=${this.API_KEY}`;

  constructor(private http: HttpClient) {}

  /**
   * Get user's country based on IP address
   * @returns Observable with country name or empty string if failed
   */
  async getUserCountry(): Promise<string> {
    try {
      const data: any = await firstValueFrom(this.http.get(this.API_URL));
      return data.location?.country?.name || '';
    } catch (error) {
      return '';
    }
  }
}
